import {createSlice, PayloadAction, createAsyncThunk} from '@reduxjs/toolkit';
import { type RootState } from '../../store';
import { AccountInfo, EventMessageUtils } from '@azure/msal-browser';
import axios from 'axios';
import IShipsConfig from '../../interfaces/config.interface';

// Define a type for the slice state
export interface ConfigState {
  shipsconfig? : IShipsConfig
}

// Define the initial state using that type
const initialState: ConfigState = {
    shipsconfig: undefined,
    
}

export const getConfig = createAsyncThunk("settings/config", async()=>{
  const response = await fetch(process.env.REACT_APP_API_URI + `/settings/config`,{
      method:"GET"
  });
  const data = response.json()
  return data;

});

export const ConfigSlice = createSlice({
  name: 'Config',
  initialState,
  reducers: {
    
  },
  extraReducers: (builder) => {
      builder.addCase(getConfig.fulfilled, (state, {payload}:PayloadAction<IShipsConfig>) => {
          state.shipsconfig = payload;
      })
    }
});
    

export const {} = ConfigSlice.actions


export default ConfigSlice.reducer